import React, { PureComponent } from 'react'
import {
  string, func, shape, bool, instanceOf,
} from 'prop-types'
import { withI18n } from '@active/react-utils/i18n'
import { format as formatDateTime } from '@active/core/datetime'
import { CreateAccountForm } from '../../Signup/components/CreateAccount'
import { ErrorContent } from '../../common/Layout'
import { CreateAccountFormDefaultTypes, CreateAccountFormPropTypes } from '../../Signup/components/CreateAccount/CreateAccountForm'
import './ReviewProfileContent.scss'

function handleCheckAccount({ resolve }) {
  resolve({
    status: 'SUCCESS', nextStep: 'detailInfo',
  })
}

function handleExistAccount() {
  // Do nothing here due to we do not handle existing account branch in front.
  // Backend will redirect to link confirm
}

function handldeValidationFailedCallback() {
}

class ReviewProfileContent extends PureComponent {
  static propTypes = {
    configureTrack: func.isRequired,

    handleReviewProfileSubmit: func.isRequired,
    cleanState: func.isRequired,

    clientConfig: shape({
      suppressActiveWaiver: bool,
      useCustomizeWaiver: bool,
      waiverAttachementObjectIds: string,
    }).isRequired,

    idpValues: shape({
      email: string,
      firstName: string,
      lastName: string,
      dob: instanceOf(Date),
      countryCode: string,
    }),

    ...CreateAccountFormPropTypes,

    hideCollectingConsents: bool,
    amEighteen: bool,
    epid: string,
    countryCodes: string,

    kcMessageType: string,
    kcErrorMessage: string,
  }

  static defaultProps = {
    idpValues: {},

    ...CreateAccountFormDefaultTypes,
    passwordField: { hidden: true, optional: true, disable: true },

    hideCollectingConsents: false,
    amEighteen: false,
    epid: undefined,
    countryCodes: undefined,

    kcMessageType: undefined,
    kcErrorMessage: undefined,
  }

  constructor(props) {
    super(props)
    this.state = {
      messageType: props.kcMessageType,
      errorMessage: props.kcErrorMessage,
    }
  }

  componentDidMount() {
    const { configureTrack } = this.props
    configureTrack({
      eventName: 'ReviewProfileContent init',
      widget: 'ReviewProfileContent',
      pageType: 'ReviewProfileContent',
    })
  }

  componentDidUpdate(prevProps) {
    const { kcMessageType, kcErrorMessage } = this.props
    if (prevProps.kcMessageType !== kcMessageType) {
      this.setState({ messageType: kcMessageType })
    }
    if (prevProps.kcErrorMessage !== kcErrorMessage) {
      this.setState({ errorMessage: kcErrorMessage })
    }
  }

  handleErrorMessage = errorMessage => {
    this.setState({
      messageType: errorMessage ? 'error' : 'info',
      errorMessage,
    })
  }

  handleSubmit = async values => {
    const {
      amEighteen, epid, countryCodes, handleReviewProfileSubmit, cleanState,
      clientConfig: { suppressActiveWaiver, useCustomizeWaiver, waiverAttachementObjectIds },
    } = this.props

    if (cleanState) {
      cleanState()
    }

    const data = {
      ...values,
      countriesInfo: countryCodes,
      firstname: values.firstName,
      lastname: values.lastName,
      regagree: true,
      suppressActiveWaiver,
      useCustomizeWaiver,
      waiverAttachementObjectIds,
      amEighteen,
    }
    if (epid) { data.epid = epid }
    const params = data
    // eslint-disable-next-line no-restricted-globals
    if (values.dob) {
      params.dob = formatDateTime('MM/dd/yyyy')(values.dob)
    }

    params.status = 'SUCCESS'
    await handleReviewProfileSubmit(params)
  }

  render() {
    const {
      handleReviewProfileSubmit, hideCollectingConsents,
      idpValues, emailField, firstNameField, lastNameField, dobField, countryField, passwordField,
      ...rest
    } = this.props
    const { messageType, errorMessage } = this.state
    const {
      email, firstName, lastName, dob, countryCode,
    } = idpValues
    return (
      <div className="passport-content review_profile_content">
        {!!errorMessage && <ErrorContent messageType={messageType} errorMsg={errorMessage} />}
        <CreateAccountForm
          {...rest}
          emailField={{
            value: email, changeAble: !email, editAble: !email, ...emailField,
          }}
          firstNameField={{ value: firstName, ...firstNameField }}
          lastNameField={{ value: lastName, ...lastNameField }}
          dobField={{ value: dob, ...dobField }}
          countryField={{ value: countryCode, ...countryField }}
          passwordField={passwordField}
          handleErrorMessage={this.handleErrorMessage}
          handleExistAccount={handleExistAccount}
          handleCreationSubmit={this.handleSubmit}
          handleCheckAccount={handleCheckAccount}
          handldeValidationFailedCallback={handldeValidationFailedCallback}
          hideCollectingConsents={hideCollectingConsents}
          ignoreCaptcha
          submitBtnLabel="passport.common.btn.save"
        />
      </div>
    )
  }
}

export default withI18n(ReviewProfileContent)
